module.exports = __webpack_public_path__ + "img/home_banner.1f33f17b.png";